export default "__VITE_ASSET__CSQT5kJb__"